import { TableRow, TableCell } from '@mui/material';
import dateFormatter from '../../../formatters/dateFormatter';

import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

const RequirementsListItem = props => {
  const hasEvidence = Boolean(props.evidenceUrl);

  return (
    <TableRow>
      <TableCell>{props.requestNumber}</TableCell>
      <TableCell>{props.testRef[0].testType}</TableCell>
      <TableCell>{props.costCenter}</TableCell>
      <TableCell>{props.candidateRef[0].nit}</TableCell>
      <TableCell>{props.candidateRef[0].name}</TableCell>
      <TableCell>{props.candidateRef[0].phoneNumber}</TableCell>
      <TableCell>{props.comment}</TableCell>
      <TableCell>{props.status}</TableCell>
      <TableCell align="center" sx={{ verticalAlign: 'middle' }}>
        <Tooltip title={hasEvidence ? 'Descargar evidencia' : 'Sin evidencia'}>
          <span>
            <IconButton
              onClick={() => {
                if (hasEvidence) {
                  props.onDownload(props.evidenceUrl);
                }
              }}
              disabled={!hasEvidence}
            >
              <DownloadIcon />
            </IconButton>

          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default RequirementsListItem;